import * as React from 'react'
import { FC } from 'react'
import Box, { BoxProps } from '@mui/material/Box'

const TargetArrow: FC<BoxProps<'svg'>> = (props) => (
  <Box
    component="svg"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 54 54"
    fill="none"
    {...props}
  >
    <path
      d="M43.715 30.2624C42.1404 40.226 33.5177 47.8772 23.1184 47.8772C11.6068 47.8772 2.24121 38.5117 2.24121 27C2.24121 15.4883 11.6068 6.12274 23.1184 6.12274C34.1895 6.12274 43.2503 14.7924 43.9297 25.6958H38.7103C38.0436 17.6713 31.3119 11.3421 23.1184 11.3421C14.4844 11.3421 7.46052 18.3659 7.46052 27C7.46052 35.6341 14.4844 42.6579 23.1184 42.6579C30.6337 42.6579 36.9236 37.3345 38.4297 30.2624H43.715ZM23.1184 16.5614C17.362 16.5614 12.6798 21.2448 12.6798 27C12.6798 32.7552 17.3632 37.4386 23.1184 37.4386C27.7346 37.4386 31.6547 34.4238 33.0275 30.2624H27.1593C26.2018 31.4459 24.7554 32.2193 23.1184 32.2193C20.2408 32.2193 17.8991 29.8776 17.8991 27C17.8991 24.1224 20.2408 21.7807 23.1184 21.7807C25.5427 21.7807 27.5695 23.4506 28.1524 25.6958H33.4669C32.8218 20.5539 28.4317 16.5614 23.1184 16.5614Z"
      fill="#FF612B"
    />
    <path
      d="M50.5598 27.3276C50.4658 27.1193 50.4658 26.8806 50.5598 26.6723L51.6785 24.2062C51.916 23.6817 51.5325 23.0861 50.9572 23.0861H46.6459C46.3348 23.0861 46.0529 23.2677 45.9233 23.5509L45.0128 25.5586H23.2466C22.4504 25.5586 21.8053 26.2037 21.8053 27C21.8053 27.7962 22.4504 28.4413 23.2466 28.4413H45.0115L45.9221 30.449C46.0503 30.7322 46.3335 30.9138 46.6446 30.9138H50.956C51.5325 30.9138 51.916 30.3182 51.6773 29.7938L50.5598 27.3276Z"
      fill="#3D3C38"
    />
  </Box>
)

export default TargetArrow
